module.exports = __webpack_public_path__ + "static/img/a2.57c806d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a2.png
// module id = Ra2j
// module chunks = 1